/** @file refuseAttachmentPrefix: att<i>. names belong to flattened attachments (R1), not agents. */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import { throwError } from '@zilo/pose3d-std/errors/throwError';

const PREFIX = /^att\d+\./;

/** Throws `VALIDATION` at `path` when `name` starts with an attachment prefix (`attachment.detach` would remove it). */
export function refuseAttachmentPrefix(name: string, path: string): void {
  if (PREFIX.test(name)) throwError(ERROR_CODES.VALIDATION, { name }, { path, hint: 'names starting att<i>. are reserved for attachments' });
}
